import { markLoginPending } from './appsflyer';
import { signinUrl } from './signin-url';

const LOG = '[instance-auth]';

/**
 * Redirect to Wix sign-in, returning to the current URL after login. Mirrors the
 * probe redirect in pages/index.tsx (`useAuthRedirect`). No-op in SSR/dev.
 */
export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;
  if (process.env.NODE_ENV === 'development') return;
  const returnUrl = window.location.href;
  // Remember we're mid-login so AppsFlyer can fire af_login once on return.
  markLoginPending();
  console.info(`${LOG} redirecting to sign-in`);
  window.location.href = signinUrl(returnUrl);
}
